import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { JiraWidgetService } from '../../../shared/services/jira-widget.service';
import { resolveDisplayTimeZone } from '../../../shared/utils/office-time-zone';

const TOKEN_KEY = 'access_token';
const USER_KEY = 'auth_user';
const PACKAGE_PAYMENT_STATUS = 'package_payment_status';

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {
  constructor(
    private router: Router,
    private jiraWidgetService: JiraWidgetService
  ) { }

  public avatarChange = new Subject<any>();

  public logout(): void {
    this.jiraWidgetService.remove();
    localStorage.clear();
    this.router.navigate(['/auth/login']);
  }

  public saveToken(token: string): void {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.setItem(TOKEN_KEY, token);
  }

  public getToken(): string | null {
    return localStorage.getItem(TOKEN_KEY);
  }

  public saveUser(user: any): void {
    localStorage.removeItem(USER_KEY);
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  }

  public getUser(): any {
    const user = localStorage.getItem(USER_KEY);
    if (user) {
      return JSON.parse(user);
    }

    return {};
  }

  /** JOB-4193. The company's zone from the API, else this browser's; never a hard-coded one. */
  public currentTimezone(): string | null {
    return resolveDisplayTimeZone(this.getUser().office_timezone);
  }

  /** JOB-4193. Keeps the stored user's zone current; a null zone means "use the browser". */
  public saveOfficeTimezone(timezone: string | null, source: string | null): void {
    const user = this.getUser();
    if (!user || !user.id) {
      return;
    }
    user.office_timezone = timezone;
    user.office_timezone_source = source;
    this.saveUser(user);
  }

  public savePackagePaymentStatus(packagePaymentStatus: string, unpaidDays: number): any {
    localStorage.removeItem(PACKAGE_PAYMENT_STATUS);
    const data: any = {packagePaymentStatus, unpaidDays};
    localStorage.setItem(PACKAGE_PAYMENT_STATUS, JSON.stringify(data));
  }

  public getPackagePaymentStatus(): any {
    return JSON.parse(localStorage.getItem(PACKAGE_PAYMENT_STATUS));
  }
}
